angular.module('picmonicng').directive('plsDragItem', [
  '$filter',
  function ($filter) {
    return {
      restrict: 'A',
      require: '^plsSortable',
      scope: {
        item: '=plsDragItem',
        disabled: '&plsDragDisabled',
      },
      link: function (scope, element, attrs, ctrl) {
        if (scope.item == ctrl.element) {
          ctrl.dom = element;
          element.css('visibility', 'hidden');
        }

        function dragStart(e) {
          element.css('visibility', 'hidden');
          scope.$apply(function () {
            ctrl.element = scope.item;
            ctrl.dom = element;
            ctrl.initialPosition = ctrl.actualPosition = ctrl.position = ctrl.scope.items.indexOf(scope.item);
          });
        }

        function dragStop(e) {
          ctrl.dom.css('visibility', 'visible');
          ctrl.scope.$apply(function () {
            ctrl.element = null;

            if (ctrl.initialPosition != ctrl.actualPosition) {
              ctrl.scope.onMove({ item: scope.item, position: ctrl.replace });
            }
          });
        }

        function dragOver(e) {
          if (scope.item == ctrl.element) {
            return false;
          }

          ctrl.actualPosition = ctrl.scope.items.indexOf(scope.item);
          ctrl.replace = scope.item;

          if (ctrl.position < ctrl.scope.items.indexOf(scope.item)) {
            scope.$apply(function () {
              ctrl.scope.items.splice(ctrl.scope.items.indexOf(ctrl.element), 1);
              ctrl.scope.items.splice(ctrl.scope.items.indexOf(scope.item) + 1, 0, ctrl.element);
            });
            ctrl.position = ctrl.scope.items.indexOf(scope.item);
          } else {
            scope.$apply(function () {
              ctrl.scope.items.splice(ctrl.scope.items.indexOf(ctrl.element), 1);
              ctrl.scope.items.splice(ctrl.scope.items.indexOf(scope.item), 0, ctrl.element);
            });
            ctrl.position = ctrl.scope.items.indexOf(scope.item) - 1;
          }
        }

        if (ctrl.useHandle) {
          element.addClass('has-sort-handle');
        }

        var draggable_default_options = {
          axis: 'y',
          helper: function () {
            var clone = element.clone();
            clone.css('width', '100%');
            return clone;
          },
          scroll: true,
          containment: 'parent',
          refreshPositions: true,
          start: dragStart,
          stop: dragStop,
          handle: ctrl.useHandle ? '.pls-list-item__image' : false,
        };

        angular.merge(draggable_default_options, ctrl.scope.plsSortable());

        element.draggable(draggable_default_options);

        element.droppable({
          over: dragOver,
        });

        scope.$watch(
          function () {
            return ctrl.scope.isDisabled() || scope.disabled();
          },
          function (value) {
            element.draggable('option', 'disabled', value);
          }
        );
      },
    };
  },
]);

angular.module('picmonicng').directive('plsSortable', [
  function () {
    return {
      restrict: 'A',
      scope: {
        items: '=ngModel',
        isDisabled: '&',
        plsSortable: '&',
        onMove: '&',
      },
      controller: [
        '$scope',
        'ngBowser',
        function ($scope, ngBowser) {
          this.scope = $scope;
          this.useHandle = ngBowser.isMobile() || ngBowser.isTablet();
        },
      ],
    };
  },
]);
